import { RecentProductVO } from './../views/biz/product/vo/product.vo';
import { MstMenuVO } from './../views/biz/main/vo/main.vo';
import CommonUtils from '@/common-utils';
import Constants from '@/constants';
import { NotificationVO } from '@/views/biz/notification/vo/notification.vo';
import axios from 'axios';
import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex)

interface Store {
  cartCount: number; // 장바구니 카운트
  newToastMessage: NotificationVO; // 신규 토스트 메세지
  hasNewNotification: boolean; // 신규 알림 있음?
  isTopMenuFixed: boolean; // 상단 메뉴 고정상태임?
  gnbMenus: Array<MstMenuVO>; // 메뉴 목록
  fromRouteName: string; // 이전 라우트명
  recentProducts: Array<RecentProductVO>; // 최근 본 상품정보 목록
  keepAliveSeq: number; // keep alive 갱신용 seq
}

export default new Vuex.Store<Store>({
  state: {
    cartCount: 0,
    newToastMessage: {} as NotificationVO,
    hasNewNotification: false,
    isTopMenuFixed: false,
    gnbMenus: [] as Array<MstMenuVO>,
    fromRouteName: "",
    recentProducts: [] as Array<RecentProductVO>,
    keepAliveSeq: 0
  },
  mutations: {
    cartCount(state, cartCount: number) {
      state.cartCount = cartCount;
    },
    newToastMessage(state, newToastMessage: NotificationVO) {
      state.newToastMessage = newToastMessage;
    },
    hasNewNotification(state, hasNewNotification: boolean) {
      state.hasNewNotification = hasNewNotification;
    },
    isTopMenuFixed(state, isTopMenuFixed: boolean) {
      state.isTopMenuFixed = isTopMenuFixed;
    },
    gnbMenus(state, gnbMenus: Array<MstMenuVO>) {
      state.gnbMenus = gnbMenus;
    },
    fromRouteName(state, fromRouteName: string) {
      state.fromRouteName = fromRouteName;
    },
    recentProductInfo(state, recentProducts: Array<RecentProductVO>) {
      state.recentProducts = recentProducts;
    },
    touchKeepAlive(state) {
      state.keepAliveSeq = state.keepAliveSeq + 1;
    }
  },
  actions: {
    // 장바구니 업데이트
    updateCartCount(context) {
      axios.get("/common/cart-count").then((r) => {
        context.commit("cartCount", r.data as number);
      });
    },
    // 신규 토스트 메세지, 알림 업데이트
    updateNotification(context) {
      axios.get("/main/last-notification").then((r) => {
        const localNotificationSeq1 = CommonUtils.getLocalStorageObject(Constants.NOTIFICATION_SEQ1) || 0; // 마지막 토스트 알림 seq
        const localNotificationSeq2 = CommonUtils.getLocalStorageObject(Constants.NOTIFICATION_SEQ2) || 0; // 마지막 알림 seq
        // 토스트 메세지
        context.commit("newToastMessage", r.data.toastNotification && r.data.toastNotification.seq > localNotificationSeq1 ? r.data.toastNotification : {});
        // 알림
        context.commit("hasNewNotification", r.data.notification && r.data.notification.seq > localNotificationSeq2);
      });
    },
    // gnb 메뉴 조회
    selectGnbMenus(context) {
      !Vue.prototype.$isMobile &&
      axios.get("/simple-menus").then((r) => {
        context.commit("gnbMenus", r.data);
      });
    },
  },
  modules: {
  }
})
